// utility to check to see if user had roles and has AsedaAdmin in roles
export function isUserAnAdmin(user) {
  // console.log('isUserAdmin ', user);
  if (user === undefined) return false;
  if (user?.authRoles && user.authRoles.includes('aseda-admin')) return true;
  if (user?.appInfo?.roles && user.appInfo.roles.includes('admin')) return true;
  return false;
}